<template>
  <div class="main">
    <div>
      <el-button size="small" @touchstart="openDialog('save')" @click="openDialog('save')">保存</el-button>
      <el-button size="small" @click="openDialog('saveAndPublish')">保存并发布</el-button>
      <el-button @touchstart="goBack()" @click="goBack()" class="float-right" size="small">
        <i class="el-icon-back"></i> 返回
      </el-button>
    </div>
    <!-- <div class="margin-top-20">
       流程名称：
       <el-input v-model="processName" size="mini"
                 style="width: 220px"></el-input>
     </div>-->
    <el-row class="margin-top-10 contentHeight">
      <el-col :lg="18" style="padding-right: 10px" class="h-100">
        <div class="h-100">
          <div class="containers" ref="containers">
            <!--左边画布-->
            <div class="canvas" ref="canvas"/>
            <!--右上角画布-->
            <div class="toolbar">
              <span class="el-icon-refresh-right pointer"
                   @touchstart="handleRedo" @click="handleRedo" title="前进"
                    style="color: #000;font-size: 1.5rem"></span>
              <span class="el-icon-refresh-left pointer margin-left-5"
                  @touchstart="handleUndo"  @click="handleUndo" title="后退"
                    style="color: #000;font-size: 1.5rem"></span>
              <span class="el-icon-zoom-in pointer margin-left-5"
                  @touchstart="handleZoom(0.2)"  @click="handleZoom(0.2)"
                    style="color: #000;font-size: 1.5rem"></span>
              <span class="el-icon-zoom-out pointer margin-left-5"
                  @touchstart="handleZoom(-0.2)"  @click="handleZoom(-0.2)"
                    style="color: #000;font-size: 1.5rem"></span>
              <span class="pointer margin-left-5"
                  @touchstart="fullScreen()"  @click="fullScreen()"
                    style="color: #000;font-size: 1.5rem">
                <i class="el-icon-full-screen" v-if="!isFullScreen"></i>
                <img src="../../../../../assets/images/icon/退出全屏.png"
                     style="margin-top: -7px" v-else>
              </span>
              <!--              <a title="download">下载</a>-->
              <a ref="saveDiagram" href="javascript:" title="download BPMN diagram"></a>
              <!--              <a ref="saveSvg" href="javascript:" title="download as SVG image">SVG</a>-->
            </div>
          </div>
        </div>
      </el-col>
      <el-col :lg="6" class="h-100">
        <div class="border-dash h-100" style="background-color: #111B31">
          <panel v-if="bpmnModeler" :modeler="bpmnModeler" :processData="processData" ref="BpmnPanel"/>
        </div>
      </el-col>
    </el-row>


    <function-dialog-component
      :closeClick="false"
      :dialogVisible.sync="dialogVisible"
      :pressClick="false"
      @dialogClose="() =>{this.dialogVisible = false;this.name= this.processData.name}"
      dialog-title="流程名称"
      width="450px">
      <div slot="content" style="padding: 20px 30px;min-height: 160px;">
        <div style="width: 80%;margin: 10px auto">
          <div class="display-flex">
            <div>流程名称：</div>
            <div style="flex-basis: calc(100% - 5rem)">
              <el-input v-model="name" size="mini"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" style="text-align: center;margin-bottom: 20px;">
        <el-button @touchstart="saveProcess" @click="saveProcess" size="mini" type="primary" :loading="loading">确认</el-button>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>
import BpmnModeler from "bpmn-js/lib/Modeler"; // bpmn-js 设计器
import panel from "./BpmnPanel"; // 属性面板
import BpmData from "@/constant/BpmData";
import {customTranslate} from "@/constant/translations";
import {activitiJson} from "@/constant/activiti";
import {getDefaultXml} from "@/constant/xmlStr";
import {getXmlById, saveProcess} from "@/network/act-de-model";
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import {stringIsNull} from "@/utils/tool";
import {publishProcess} from "@/network/activiti";
import _ from 'lodash'
// import paletteEntries from '../../../../../assets/js/bpmn/config/paletteEntries'
// import customRenderer from '../../../../../assets/js/bpmn/renderer/index'

export default {
  name: "EditProcess",
  components: {
    panel, FunctionDialogComponent
  },
  data() {
    return {
      bpmnModeler: null,
      processId: null,
      bpmnXmlStr: "",
      element: null,
      bpmData: new BpmData(),
      dialogVisible: false,
      operate: '',
      name: "",
      devicePointList: [],
      processData: {},
      scale: 1,
      copy: null,
      isFullScreen: false,
      loading: false,
    };
  },
  // destroyed() {
  //   this.bpmnModeler.destroyed()
  // },
  mounted() {
    window.addEventListener('resize', () => {
      this.isFullScreen = !!(document.webkitIsFullScreen || document.mozFullScreen ||
        document.msFullscreenElement || document.fullscreenElement)
    }, false)
    const canvas = this.$refs.canvas;
    // 生成实例
    this.bpmnModeler = new BpmnModeler({
      container: canvas,
      additionalModules: [
        // customRenderer,
        {
          translate: ['value', customTranslate]
        }
      ],
      moddleExtensions: {
        activiti: activitiJson
      }
    });
    if (this.$route.query.id) {
      this.processId = this.$route.query.id
      this.copy = this.$route.query.copy
      this.getXmlById()
    } else {
      this.bpmnXmlStr = getDefaultXml()
      this.createNewDiagram();
    }

    // 获取a标签dom节点
    const downloadLink = this.$refs.saveDiagram;
    // const downloadSvgLink = this.$refs.saveSvg;
    // 监听流程图改变事件
    const _this = this;
    this.bpmnModeler.on("commandStack.changed", function () {
      // _this.saveSVG(function (err, svg) {
      //   _this.setEncoded(downloadSvgLink, "diagram.svg", err ? null : svg);
      // });
      _this.saveDiagram(function (err, xml) {
        _this.setEncoded(downloadLink, "diagram.bpmn", err ? null : xml);
      });
    });
  },
  methods: {
    goBack() {
      this.$router.push('/strategy/process');
    },
    getXmlById() {
      getXmlById(this.processId).then(res => {
        if (res.code === 0) {
          this.bpmnXmlStr = res.data.xml
          this.xmlStr = res.data.xml
          this.name = res.data.name
          this.processData = res.data
          // 新增流程定义
          this.createNewDiagram();
        }
      })
    },
    createNewDiagram: function () {
      // 将字符串转换成图显示出来
      this.bpmnModeler.importXML(this.bpmnXmlStr, err => {
        // eslint-disable-next-line no-empty
        if (err) {
          return console.error('could not import BPMN 2.0 diagram', err);
        } else {
          this.adjustPalette();
        }
      });
    },
    // 调整左侧工具栏排版
    adjustPalette() {
      try {
        // 获取 bpmn 设计器实例
        const canvas = this.$refs.canvas;
        const djsPalette = canvas.children[0].children[1].children[4];
        const djsPalStyle = {
          width: "120px",
          padding: "5px",
          background: "white",
          left: "20px",
          borderRadius: 0
        };
        for (var key in djsPalStyle) {
          djsPalette.style[key] = djsPalStyle[key];
        }
        const palette = djsPalette.children[0];
        const allGroups = palette.children;
        allGroups[0].style["display"] = "none";
        // 修改控件样式
        for (var gKey in allGroups) {
          const group = allGroups[gKey];
          for (var cKey in group.children) {
            const control = group.children[cKey];
            const controlStyle = {
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              width: "100%",
              padding: "5px"
            };
            if (
              control.className &&
              control.dataset &&
              control.className.indexOf("entry") !== -1
            ) {
              const controlProps = this.bpmData.getControl(
                control.dataset.action
              );
              control.innerHTML = `<div style='font-size: 13px;font-weight:500;margin-left:10px;'>${
                controlProps["title"]
              }</div>`;
              for (let csKey in controlStyle) {
                control.style[csKey] = controlStyle[csKey];
              }
            }
          }
        }
        // eslint-disable-next-line no-empty
      } catch (e) {
      }
    },
    // 下载为SVG格式,done是个函数，调用的时候传入的
    saveSVG(done) {
      // 把传入的done再传给bpmn原型的saveSVG函数调用
      this.bpmnModeler.saveSVG(done);
    },
    // 下载为SVG格式,done是个函数，调用的时候传入的
    saveDiagram(done) {
      // 把传入的done再传给bpmn原型的saveXML函数调用
      this.bpmnModeler.saveXML({format: true}, function (err, xml) {
        done(err, xml);
      });
    },
    // 当图发生改变的时候会调用这个函数，这个data就是图的xml
    setEncoded(link, name, data) {
      // 把xml转换为URI，下载要用到的
      const encodedData = encodeURIComponent(data);
      // 获取到图的xml，保存就是把这个xml提交给后台
      this.xmlStr = data;
      // 下载图的具体操作,改变a的属性，className令a标签可点击，href令能下载，download是下载的文件的名字
      if (data) {
        link.className = "active";
        link.href = "data:application/bpmn20-xml;charset=UTF-8," + encodedData;
        link.download = name;
      }
    },
    handleRedo() {
      this.bpmnModeler.get('commandStack').redo();
    },
    handleUndo() {
      this.bpmnModeler.get('commandStack').undo();
    },
    handleZoom(flag) {
      if (flag < 0 && this.scale <= 0.5) {
        return;
      }
      this.scale += flag;
      this.$nextTick(() => {
        this.bpmnModeler.get('canvas').zoom(this.scale)
      })
    },
    fullScreen() {
      if (this.isFullScreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        }
      } else {
        let element = this.$refs.containers
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen()
        }
      }
    },
    openDialog(operate) {
      console.log(this.xmlStr);
      if (stringIsNull(this.xmlStr)) {
        this.$message.error("流程图不能为空!")
        return false;
      }
      if (this.$refs.BpmnPanel.nodeNoData.length > 0) {
        const node = this.$refs.BpmnPanel.nodeNoData[0]
        this.$message.error("流程图节点" + node.name + node.id + "数据不能为空!")
        return false;
      }
      this.operate = operate
      this.dialogVisible = true
    },
    saveProcess() {
      if (stringIsNull(this.name)) {
        this.$message.error("流程名称不能为空!")
        return false;
      }
      this.loading = true
      const data = {...this.processData}
      data.name = this.name
      data.xml = this.xmlStr
      data.description = JSON.stringify(this.$refs.BpmnPanel.selectList)
      if (this.copy === 'true') {
        data.id = null
      }
      this.saveOrPublishProcess(data, this)
    },
    saveOrPublishProcess: _.debounce(function (data) {
      //注意这里如果使用箭头函数的话， this为 undefined
      if (this.operate === 'saveAndPublish') {
        publishProcess(data).then(res => {
          if (res.code === 0) {
            this.$message.success("保存并发布成功!")
            this.loading = false
            this.processData.id = res.data
          }
          this.dialogVisible = false;
        })
      } else {
        saveProcess(data).then(res => {
          if (res.code === 0) {
            this.processData.id = res.data
            this.loading = false
            this.$message.success("保存成功!")
            this.dialogVisible = false;
          }
        })
      }
    }, 500)
  },
}
</script>

<style scoped>
.main {
  padding: 15px 10px 0 10px;
  overflow: auto;
}

.contentHeight {
  height: calc(100% - 50px);
}
</style>

<style lang="scss">
/*左边工具栏以及编辑节点的样式*/
@import "~bpmn-js/dist/assets/diagram-js.css";
@import "~bpmn-js/dist/assets/bpmn-font/css/bpmn.css";
@import "~bpmn-js/dist/assets/bpmn-font/css/bpmn-codes.css";
@import "~bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css";

.containers {
  position: relative;
  background-color: #ffffff;
  width: 100%;
  height: 100%;

  .canvas {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
  }

  .panel {
    position: absolute;
    right: 0;
    top: 50px;
    width: 300px;
  }

  .bjs-powered-by {
    display: none;
  }

  .toolbar {
    position: absolute;
    top: 10px;
    right: 10px;

    a {
      text-decoration: none;
      margin: 5px;
      color: #409eff;
    }
  }

  .djs-context-pad .entry, .djs-popup-body {
    color: #000 !important;
  }
}
</style>
